@if (enabled) {
  <app-cancel-policy-modal
    [flow]="flow"
    (cancellationCreated)="refreshTaskDetails(true)"
  >
    <app-trash-2-icon
      height="16px"
      width="16px"
      color="var(--error-600)"
      ngbTooltip="Résilier la police"
      i18n-ngbTooltip
      trigger
    />
  </app-cancel-policy-modal>
}
